import { Phone } from "lucide-react";
import { restaurant } from "../data";

export default function FloatingCall() {
  return (
    <a
      href={restaurant.phoneHref}
      data-testid="floating-call-btn"
      className="fixed bottom-5 right-5 z-50 sm:hidden inline-flex items-center gap-2 rounded-full bg-[#e05d36] text-black font-bold px-6 py-4 shadow-2xl shadow-black/50 active:scale-95 transition-transform duration-150"
    >
      <Phone size={20} strokeWidth={2.5} />
      Anrufen
    </a>
  );
}
